import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Candidatura",
    body: "Compili un breve form. Poche domande, molto oneste. Servono a capire se possiamo davvero lavorare insieme.",
  },
  {
    n: "02",
    title: "Selezione",
    body: "Valuto ogni candidatura di persona. Se non sono la persona giusta per te, te lo dico con chiarezza. Senza giri di parole.",
  },
  {
    n: "03",
    title: "Call conoscitiva",
    body: "30 minuti, gratuiti e senza vendite. Solo una conversazione onesta per mettere a fuoco dove sei e dove vuoi arrivare.",
  },
  {
    n: "04",
    title: "Percorso su misura",
    body: "Se c'è allineamento, costruiamo insieme un percorso disegnato sulla tua vita e sui tuoi obiettivi reali.",
  },
];

export default function Method() {
  return (
    <section
      id="metodo"
      className="relative bg-background py-28 md:py-40 border-t border-white/10"
      data-testid="method-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.35em] text-primary">
              IL PERCORSO
            </span>
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight">
            Un imbuto etico. Pochi passi, molta verità.
          </h2>
          <p className="mt-6 text-muted-foreground max-w-xl leading-relaxed">
            Non prendo tutti. Questo processo esiste per proteggere il tuo tempo
            e il mio — e per garantire risultati reali a chi è davvero pronto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-card p-8 md:p-10 min-h-[300px] flex flex-col justify-between hover:bg-secondary transition-colors duration-500"
              data-testid={`method-step-${s.n}`}
            >
              <span className="font-serif text-5xl text-primary/40 group-hover:text-primary transition-colors duration-500">
                {s.n}
              </span>
              <div>
                <h3 className="font-serif text-2xl text-foreground mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {s.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
